export const CircleFlagCs = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask
        id="mask0_284:30036"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="30"
        height="30"
      >
        <circle
          cx="20"
          cy="20"
          r="14.375"
          fill="#C4C4C4"
          stroke="black"
          strokeWidth="1.25"
        />
      </mask>
      <g mask="url(#mask0_284:30036)">
        <rect
          x="-6.25"
          y="5"
          width="52.5"
          height="31.875"
          fill="url(#pattern0)"
        />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_284:30036"
            transform="translate(0 -0.0490196) scale(0.00444444 0.00732026)"
          />
        </pattern>
        <image
          id="image0_284:30036"
          width="225"
          height="150"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
